// src/routes/profileCompletionSession.js

const PROFILE_COMPLETION_GRACE_MS = 2 * 60 * 1000;

const KEYS = {
  justCompleted: "locreach:profileJustCompleted",
  forceRefresh: "locreach:forceProfileRefresh",
  completedAt: "locreach:profileCompletedAt",
};

export function markProfileJustCompleted() {
  try {
    const now = Date.now();

    sessionStorage.setItem(KEYS.justCompleted, "true");
    sessionStorage.setItem(KEYS.forceRefresh, "true");
    sessionStorage.setItem(KEYS.completedAt, String(now));
  } catch {
    // Ignore storage failures. Navigation must not depend on storage support.
  }
}

export function hasRecentlyCompletedProfile() {
  try {
    const justCompleted = sessionStorage.getItem(KEYS.justCompleted) === "true";
    const completedAt = Number(sessionStorage.getItem(KEYS.completedAt) || 0);

    if (!justCompleted) return false;
    if (!Number.isFinite(completedAt) || completedAt <= 0) return false;

    return Date.now() - completedAt < PROFILE_COMPLETION_GRACE_MS;
  } catch {
    return false;
  }
}

export function shouldForceProfileRefresh() {
  try {
    return sessionStorage.getItem(KEYS.forceRefresh) === "true";
  } catch {
    return false;
  }
}

export function clearProfileCompletionSession() {
  try {
    sessionStorage.removeItem(KEYS.justCompleted);
    sessionStorage.removeItem(KEYS.forceRefresh);
    sessionStorage.removeItem(KEYS.completedAt);
  } catch {
    // Ignore storage failures.
  }
}
